module.exports = __webpack_public_path__ + "ca84e5775e93e87fbedadbd01dcd971f.ttf";